import { SessionProvider } from 'next-auth/react'
import { AppProps } from 'next/app'
import Head from 'next/head'
import { RestrictionContextProvider } from '@src/context/RestrictionContext'
import { CaptionsContextProvider } from '@src/context/CaptionsContext'
import { ConfigContextProvider } from '@src/context/ConfigContext'
import { AdminUiContextProvider } from '@src/context/AdminUiContext'
import { LanguageContextProvider } from '@src/context/LanguageContext'
import '../styles/global.css'
import 'react-quill/dist/quill.snow.css'

const App: React.FC<AppProps> = ({ Component, pageProps }) => (
  <>
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      {/* eslint-disable-next-line */}
      <script type="text/javascript" src="/__ENV.js" />
    </Head>
    <SessionProvider session={pageProps.session}>
      <ConfigContextProvider>
        <RestrictionContextProvider>
          <LanguageContextProvider>
            <CaptionsContextProvider>
              <AdminUiContextProvider>
                <Component {...pageProps} />
              </AdminUiContextProvider>
            </CaptionsContextProvider>
          </LanguageContextProvider>
        </RestrictionContextProvider>
      </ConfigContextProvider>
    </SessionProvider>
  </>
)

export default App
